export default __webpack_public_path__ + "static/media/strelica.7ba9d4b7.svg";